import { render, staticRenderFns } from "./second_menuComputer_PriceAndInventory.vue?vue&type=template&id=bf422520&scoped=true"
import script from "./second_menuComputer_PriceAndInventory.vue?vue&type=script&lang=js"
export * from "./second_menuComputer_PriceAndInventory.vue?vue&type=script&lang=js"
import style1 from "./second_menuComputer_PriceAndInventory.vue?vue&type=style&index=1&id=bf422520&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf422520",
  null
  
)

export default component.exports